import { createSlice } from "@reduxjs/toolkit";

const initialCurrentUser = {
  userType: null,
  imgURL: null,
  isSuperUser: false,
};
const initialState = {
  currentUser: initialCurrentUser,
  isAuthenticated: false,
  loading: false,
  error: null,
  token: null,
  version: '0',
  accountTransition: false
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCurrentUser: (state, action) => {
      const payload = action.payload || {};
      const { userType, imgURL, ...rest } = payload;

      state.currentUser = {
        ...initialCurrentUser,
        ...rest,
        userType: state.currentUser?.userType ?? initialCurrentUser.userType,
        imgURL: state.currentUser?.imgURL ?? initialCurrentUser.imgURL,
      };
    },
    setAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setVersion: (state, action) => {
      state.version = action.payload;
    },
    setAccountTransition: (state, action) => {
      state.accountTransition = action.payload;
    },
    setUserType: (state, action) => {
      state.currentUser = state.currentUser || { ...initialCurrentUser };
      state.currentUser.userType = action.payload;
    },
    setImgUser: (state, action) => {
      const next = action.payload || "";
      state.currentUser = {
        ...state.currentUser,
        imgURL: next,
      };
    },
    logout: () => initialState,
  },
});

export const { setCurrentUser, setAuthenticated, setLoading, setError, setToken, setVersion, setAccountTransition, setUserType, setImgUser, logout } = authSlice.actions;
export default authSlice.reducer;
